import { CreateOrderRequest } from '@/typings/http/order';
import makeAxiosClient from '@/helpers/axios';
import { Order } from '@/typings/entity/order';

export async function createOrder(payload: CreateOrderRequest) {
  return makeAxiosClient()
    .post<Order>('/order', payload)
    .then((res) => res.data);
}
